import React, { Fragment } from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { t } from 'Src/i18n';
import { Scrollable } from 'Components/frameworks/scrollable/Scrollable';
import { Title } from 'Components/frameworks/title/Title';
import { AlternativeResortThumbnail } from './AlternativeResortThumbnail';
import { AlternativeResortCriteria } from './AlternativeResortCriteria';
type Props = {
  adultsNumber: number;
  arrivalDate: string;
  categoryGA?: string;
  departureCity: string;
  duration: number;
  kidsNumber: number;
  suggestions: ReadonlyArray<ResortSuggestion>;
  selectResortHandler?: (id: string, name: string) => unknown;
  scrollToBookingEngineEntryPoint?: () => void;
};
export const AlternativeResort = ({
  adultsNumber,
  arrivalDate,
  categoryGA = 'resort',
  departureCity,
  duration,
  kidsNumber,
  suggestions,
  selectResortHandler,
  scrollToBookingEngineEntryPoint,
}: Props) => {
  const { isTablet } = useResponsive();
  return (
    <div data-testid="AlternativeResort">
      <Title className="mb-20" theme="title-brand-n1">
        {t('booking.counterProposalPopIn.resortCounterProposalTitle')}
      </Title>
      <div className="grid grid-cols-1 gap-20 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        <AlternativeResortCriteria
          adultsNumber={adultsNumber}
          arrivalDate={arrivalDate}
          className="flex-1"
          departureCity={departureCity}
          duration={duration}
          kidsNumber={kidsNumber}
        />
        {isTablet ? (
          <Fragment>
            {suggestions.map((suggestion) => (
              <AlternativeResortThumbnail
                categoryGA={categoryGA}
                key={suggestion.resort.id}
                onClick={selectResortHandler}
                scrollToBookingEngineEntryPoint={scrollToBookingEngineEntryPoint}
                suggestion={suggestion}
              />
            ))}
          </Fragment>
        ) : (
          <Scrollable
            className="-mx-20"
            backwardLabel={t('common.scrollBackward')}
            forwardLabel={t('common.scrollForward')}
          >
            <div className="flex gap-10 px-20">
              {suggestions.map((suggestion) => (
                <AlternativeResortThumbnail
                  categoryGA={categoryGA}
                  className="last:scroll-x-ghost-m-20 last:scroll-x-ghost-m w-280 flex-none"
                  key={suggestion.resort.id}
                  onClick={selectResortHandler}
                  scrollToBookingEngineEntryPoint={scrollToBookingEngineEntryPoint}
                  suggestion={suggestion}
                />
              ))}
            </div>
          </Scrollable>
        )}
      </div>
    </div>
  );
};
